import '@telegram-apps/telegram-ui/dist/styles.css';
import './index.css';
import '../mockEnv.ts';

import { initSentry } from './sentry.ts';
initSentry();

import ReactDOM from 'react-dom/client';

import { init } from '@/init.ts';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { retrieveLaunchParams } from '@telegram-apps/sdk-react';
import { AppRoot } from '@telegram-apps/telegram-ui';

import { App } from './app.tsx';
import { EnvUnsupported } from '@/widgets/errors/index.ts';
import { I18nextProvider } from 'react-i18next';
import i18n from '@/shared/i18n/i18n.ts';

const root = ReactDOM.createRoot(document.getElementById('root')!);

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
});

try {
  const launchParams = retrieveLaunchParams();

  const { tgWebAppPlatform: platform } = launchParams;
  const debug = (launchParams.tgWebAppStartParam || '').includes('platformer_debug') || import.meta.env.DEV;
  init({
    debug,
    eruda: debug && ['ios', 'android'].includes(platform),
    mockForMacOS: platform === 'macos',
  }).then(() => {
    root.render(
      <QueryClientProvider client={queryClient}>
        <I18nextProvider i18n={i18n}>
          <AppRoot platform="ios" appearance="light">
            <App />
          </AppRoot>
        </I18nextProvider>
      </QueryClientProvider>,
    );
  });
} catch (e) {
  root.render(<EnvUnsupported />);
}
